import React, {
    useState
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import {
    ActionButtons,
    ActionButtonTypes,
    buildActionButton, NumberPlateColumnType, ParkingEventIsCheckedColumnType
} from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";
import ParkingEventRepository from "../../../repositories/ParkingEventRepository";
import ParkingEventLogView from "../../AuditLog/ParkingEventLog";
import {Filter} from "./Filter";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import useAlert from "../../../hooks/useAlert";
import {format} from "date-fns";
import JobsService from "../../../services/JobsService";
import { saveAs } from 'file-saver'
import ParkingEventDetailView from "../View";

const ParkingEventListView = () => {

	const navigate = useNavigate();
	const repository = new ParkingEventRepository();
	const {t}  = useTranslation();
    const [showLog, setShowLog] = useState(null);
    const [showEventView, setShowEventView] = useState(null);
    const [list, setList] = useState([]);
    const {showSuccess, showError} = useAlert();
	const [blockedWindow, setBlockedWindow] = useState(false);

    const handleEditItemClick = (event) => {
	    navigate("/app/parking-events/" + event.Id);
    }

    const onViewLogsHandler = (event) => {
        setShowLog(event.Id);
    }

    const onViewDetailsHandler = (event) => {
        setShowEventView(event.Id);
    }

    const handleOnDownload = async (e) => {
	    setBlockedWindow(true);
	    try {
            const response = await repository.export(Object.assign({}, filter, { sort: sort }));
            const fileName = "[" + filter.DateFrom + " - " + filter.DateTo + "] - Events.csv";
            saveAs(response.data, fileName);
        } catch (e) {
        } finally {
            setBlockedWindow(false);
        }
    }

    const onVerifyEventHandler = async (event) => {
        try {
            const service = new JobsService();
            await service.verifyParkingEvent(event.Id);
            showSuccess(t('Verification job scheduled'));
        } catch (e) {
            showError(e);
        }
    }

    const onDataUpdate = (newData) => {
        setList(newData);
    }

    const today = format(new Date(), 'yyyy-MM-dd');
	const defaultFilter = { DateFrom: today, DateTo: today };

	const {
        totalCount,
        itemsOnPage,
        onPage,
        isSearching,
        onFilterChangedHandler,
        onSortChangedHandler,
        filter,
        sort,
        updateGrid,
        setFilterValue } = useGrid(repository, { onEdit: handleEditItemClick, defaultFilter: defaultFilter, defaultSort: 'Id|desc', onDataUpdate: onDataUpdate });

	const columns = [
      { field: 'Id', headerName: t('ID'), width: 90, sortable: false },
      { field: 'ParkingZoneName', headerName: t('Parking zone'), width: 200, sortable: false  },
      { field: 'NumberPlate', headerName: t('Plate'), ... NumberPlateColumnType  },
      { field: 'EntryDate', headerName: t('Entry'), width: 170, sortable: false  },
      { field: 'ExitDate', headerName: t('Exit'), width: 170, sortable: false  },
      { field: 'VerificationStatus', headerName: t('Status'), width: 70, sortable: false, ... ParkingEventIsCheckedColumnType()  },
      {
          headerName: t('Actions'),
          field: 'edit',
          ...ActionButtons([
              buildActionButton(ActionButtonTypes.LOGS, t("Activity log"), onViewLogsHandler),
              buildActionButton(ActionButtonTypes.VIEW, t("View details"), onViewDetailsHandler),
              buildActionButton(ActionButtonTypes.VERIFY, t("Verify"), onVerifyEventHandler, (row) => { return row.VerificationStatus == 1 || row.VerificationStatus == 5 || row.VerificationStatus == 10 }) ])
      }
    ];

	return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <>
                {showEventView && <ParkingEventDetailView id={showEventView} onClose={e => setShowEventView(null)} />}
                {showLog && <ParkingEventLogView id={showLog} onClose={e => setShowLog(null)} />}

                <GridSkeleton title={t("Parking events")}
                          isSearching={isSearching}
                          isBlocked={blockedWindow}
                          header={(<Header onRefresh={updateGrid} onDownload={handleOnDownload} />)}
                          filter={(<Filter onUpdateFilter={setFilterValue} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort}/>)}
                          grid={(<DataGrid
                                       disableMultipleSelection={true}
                                       disableColumnFilter
                                       rows={list}
                                       rowCount={totalCount()}
                                       columns={columns}
                                       pageSize={itemsOnPage}
                                       paginationMode="server"
                                       sortingMode="server"
                                       disableColumnSelector={true}
                                       disableSelectionOnClick={true}
                                       disableColumnMenu={true}
                                       onPageChange={onPage}
                                       rowsPerPageOptions={[itemsOnPage]}
                                       hideFooterSelectedRowCount={true}
                             />)}
            />
            </>
        </MuiPickersUtilsProvider>
	);
};

export default ParkingEventListView;
